import dayjs, { dateTimeDisplayFormat } from '~libs/dayjs';

/**
 * Shared formatter for the last-sent-at datetime surfaced in both the client-signups
 * table (`list.ts` Last Sent column) and the SendLinkButton tooltip. Uses the
 * canonical `dateTimeDisplayFormat` from ~libs/dayjs. Null/undefined renders as an
 * em-dash for the table; callers with guaranteed non-null values simply get the
 * formatted string.
 */
export const formatSentAt = (value: string | null | undefined): string => {
  if (!value) return '-';
  return dayjs(value).format(dateTimeDisplayFormat);
};
